export default {
  data () {
    return {
      transactionToEditId: 0,
      preloadreceiptId: 0,
      showExpenseReceiptPreviewModalFlag: false,
      expenseType: '',
      showCreateExpenseModalFlag: false,
      showCreateMileageModalFlag: false,
      showCreateDietModalFlag: false,
      showConfirmDeleteTransactionModalFlag: false,
      isSettingReviewStatus: false,
      showTransactionReceiptModalFlag: false
    }
  },
  methods: {
    showCreateExpenseModal (event) {
      if (typeof event === 'number') {
        this.transactionToEditId = event
      } else {
        this.transactionToEditId = 0
      }
      this.showCreateExpenseModalFlag = true
      this.showEditTransactionModalFlag = false
      this.showCreateMileageModalFlag = false
      this.showCreateDietModalFlag = false
    },
    showCreateMileageModal (event) {
      if (typeof event === 'number') {
        this.transactionToEditId = event
      } else {
        this.transactionToEditId = 0
      }
      this.showEditTransactionModalFlag = false
      this.showCreateMileageModalFlag = true
      this.showCreateExpenseModalFlag = false
      this.showCreateDietModalFlag = false
    },
    showDietModal (event) {
      if (typeof event === 'number') {
        this.transactionToEditId = event
      } else {
        this.transactionToEditId = 0
      }
      this.showCreateDietModalFlag = true
      this.showEditTransactionModalFlag = false
      this.showCreateMileageModalFlag = false
      this.showCreateExpenseModalFlag = false
    },
    showConfirmDeleteTransactionModal (event) {
      this.showConfirmDeleteTransactionModalFlag = true
      this.transactionToEditId = event
    },
    handleCloseTransactionReceiptModal () {
      this.transactionToEditId = 0
      if (this.showTransactionReceiptModalFlag) {
        this.showTransactionReceiptModalFlag = false
        this.$store.dispatch('TransactionsStore/setReceiptModalIsOpen', false)
      }
    },

    async handleBudgetUpdate () {
      await this.$store.dispatch('BudgetsStore/fetchBudget', this.budgetId)
      await this.fetchTransactions()
      this.transactionToEditId = 0
      this.showTransactionsEditModalFlag = false
    },
    async deleteTransaction () {
      await this.$store.dispatch('TransactionsStore/deleteTransaction', this.transactionToEditId)
      this.showCreateDietModalFlag = false
      this.showEditTransactionModalFlag = false
      this.showCreateMileageModalFlag = false
      this.showCreateExpenseModalFlag = false
      this.showDetailTransactionModalFlag = false
      this.showConfirmDeleteTransactionModalFlag = false
      this.showDetailDietModalFlag = false
      this.showDetailMileageModalFlag = false
    }

  }
}
